module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали тарифного плана\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'rate-plan-edit',
        params: {
          id: _vm.rate_plan.id
        }
      }
    }
  }, [_vm._v("Редактировать информацию")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'rate-plans'
      }
    }
  }, [_vm._v("← Назад к Тарифным планам")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Название")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rate_plan.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Тариф в месяц")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toMoney(_vm.rate_plan.amount)))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Периодичность (дней)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rate_plan.period))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата начала")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.rate_plan.start_date)))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата окончания")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.rate_plan.end_date)))])]) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Последняя проплата")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.rate_plan.last_payment)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Следующая проплата")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.rate_plan.next_payment)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Общее кол-во проплат за период")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rate_plan.payments_count))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Общая сумма за весь период")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toMoney(_vm.rate_plan.total)))])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ae80b10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rate_plan/RatePlanDetails.vue
// module id = 652
// module chunks = 0